module.exports = __webpack_public_path__ + "img/b6.da4e2894.jpg";